import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class MessageCenterBadgeService {
    private readonly apiUrl = 'bff/conversations/unread-count';
    private readonly unreadCountSubject = new BehaviorSubject<number>(0);
    unreadCount$ = this.unreadCountSubject.asObservable();

    constructor(private readonly http: HttpClient) {}

    getUnreadMessageCount(): Observable<{ count: number }> {
        return this.http.get<{ count: number }>(this.apiUrl).pipe(
            tap((res) => this.unreadCountSubject.next(+res)),
            catchError(() => {
                return this.handleUnreadCountFetchError();
            })
        );
    }

    refreshUnreadCount(): void {
        this.getUnreadMessageCount().subscribe({
            next: (response) => {
                if (+response === 0) {
                    this.handleUnreadCount(0);
                } else {
                    this.handleUnreadCount(+response);
                }
            },
            error: () => {
                this.handleUnreadCount(0);
            }
        });
    }

    handleUnreadCount(count: number): void {
        this.unreadCountSubject.next(count);
    }

    handleUnreadCountFetchError(): Observable<{ count: number }> {
        return of({ count: 0 });
    }
}
